/* eslint-disable no-irregular-whitespace */
import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Footer } from '../../../../components/footer';
import GrHeader from '../../../../components/grHeader';
import Qrcode from '../../../../components/qrcode';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const { content } = this.props;

            const { header, qrCodeInfo, jobid } = content;

            return (
                <div>
                    <div className={styles.col}>
                        <GrHeader content={header} current={5} />
                        <div>
                            {jobid ? (
                                <iframe
                                    frameBorder={0}
                                    scrolling="yes"
                                    className={styles.iframeBox}
                                    src={`https://app.mokahr.com/apply/ifeng/17945?_iframe=1/#/job/${jobid}/apply?pure=1`}
                                />
                            ) : null}
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
